import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { Button, Divider } from 'semantic-ui-react'
import { getFormValues } from 'redux-form'
import { Fade } from '@material-ui/core'
import r from 'reactotron-react-js'

import { StdCard } from 'components'
import FieldAttachment from './FieldAttachment'
import {FileRow} from './FileRow'
import { ProcurementBody } from '../../../styled'
import { AttachmentInfoContainer } from './styled'
import { AttachmentContainer2, Cont2, SContDetail, AttachmentGroup, AttachmentContent } from './styled'

const Attachment = (props) => {
  const { 
    valueForm,
    isEdit = true
  } = props

  var commentAttachments = []

  if (valueForm) {
    if (isEdit) {
      commentAttachments = valueForm && valueForm.attachments ? valueForm.attachments.filter(x => x.commentId != null) : []
    } else {
      commentAttachments = valueForm && valueForm.attachments ? valueForm.attachments.find(x => x.attachTypeName === 'comment').item : []
    }
  }

  const setAttachment = () => {
    if (valueForm) {
      return valueForm.attachments.map((item, i) => {
        if (item.attachTypeName !== 'comment') {
          return (
            <FileRow attachmentTitle={item.attachTypeName} files={item.item} />
          )
        } else {
          return null
        }
      })
    }
    return null
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title='Attachments'>
          {isEdit ? (
            <FieldAttachment />
          ) : (
            <AttachmentInfoContainer>
              {valueForm&&setAttachment()}
            </AttachmentInfoContainer>
          )}
          <div>
            <span>หมายเหตุ / Note: </span>
            <ul style={{marginTop:'0.3rem'}}>
              <li>รองรับได้สูงสุด 250 MB ต่อไฟล์ / The maximum file size is 250 MB (per file).</li>
              <li>ความเร็วและข้อผิดพลาดในการอัพโหลด/ดาวน์โหลดไฟล์ขนาดใหญ่ ขึ้นอยู่กับอินเตอร์เน็ตที่ท่านใช้งาน / The speed and error in uploading or downloading depend on your internet connection.</li>
            </ul>
          </div>
        </StdCard>
        {commentAttachments.length ? 
          <StdCard title='Attachments (from comment)' style={{ marginTop: '15px' }} >
            <AttachmentContainer2>
              <Cont2>
                {
                  valueForm.comments.map(a => {
                    let files = commentAttachments.filter(x => x.commentId === a.id)
                    if (files.length) {
                      return(
                        <AttachmentGroup>
                          <div className='attachmentBy'>
                            <span>{a.createdByName}</span>
                            <Moment format='DD MMM YYYY hh:mm'>{a.createdDate}</Moment>
                          </div>
                          <AttachmentContent>
                            {
                              files.map((f,i) => 
                                <SContDetail style={i === 0 ? { marginTop: '0px' } : null}>
                                  {/* <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(f.urlPath,"_blank"))}/> */}
                                  <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = f.urlPath)}/>
                                </SContDetail>
                              )
                            }
                            <Divider/>
                          </AttachmentContent>
                        </AttachmentGroup>
                      )
                    } else {
                      return null
                    }
                  })
                }
              </Cont2>
            </AttachmentContainer2>
          </StdCard> : null
        }
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formEditPR')(state),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)
